import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { GetMetricDataPointsByIdsRequest } from '../../ts/ServerApi/requests/GetMetricDataPointsByIdsRequest';
import { RequestHeaders } from '../../httpClient/serverApi/requests/Request';
import { IMetricDataList } from '../../ts/ServerApi/types/IMetricDataList';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';

export const MetricDataPoints = {
  getMetricDataPoints(metricIds: string[], headers?: RequestHeaders): Promise<IMetricDataList> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(metricIds, (metricIds) => new GetMetricDataPointsByIdsRequest({metricIds}, headers)),
      (results: IMetricDataList[]) => {
        return {
          failures: results.reduce((r, c) => Object.assign(r, c.failures), {}),
          data: results.reduce((r, c) => Object.assign(r, c.data), {}),
        };
      }
    );
  }
};

export type MetricDataPoints = typeof MetricDataPoints;
